(() => {
  const courses = {
    trico: 'Tricopigmentation capillaire', dermo: 'Dermopigmentation réparatrice',
    lifting: 'Lifting colombien', hydrafacial: 'Hydra Skin',
    'hydra-skin': 'Hydra Skin', hydraskin: 'Hydra Skin',
    lipocavitation: 'Lipocavitation et radiofréquence', blanchiment: 'Blanchiment dentaire',
    taches: 'Taches de rousseur', collagene: 'Fils de collagène',
    led: 'Luminothérapie', hygiene: 'Hygiène et salubrité'
  };
  const registration = document.querySelector('dt-registration-form');
  if (!registration) return;
  const key = new URLSearchParams(window.location.search).get('formation');
  const requested = Object.prototype.hasOwnProperty.call(courses, key) ? courses[key] : '';
  const courseName = value => /^(?:hydra\s*faciale?|hydra[ -]?skin)$/i.test(value.trim()) ? 'Hydra Skin' : value;
  const banner = document.querySelector('.dc-selected-course');
  let applied = false;
  const choices = () => Array.from(registration.querySelectorAll('input[type="checkbox"]')).filter(input => input.name === 'Quelles formations vous intéressent ?');
  const syncBanner = () => {
    if (!banner) return;
    const selected = choices().filter(input => input.checked).map(input => courseName(input.value));
    banner.hidden = !selected.length;
    const title = banner.querySelector('[data-selected-course-name]');
    const help = banner.querySelector('[data-selection-help]');
    const programmes = banner.querySelector('[data-selected-programmes]');
    if (programmes) {
      let visible = false;
      programmes.querySelectorAll('[data-programme-course]').forEach(link => {
        const course = courses[link.dataset.programmeCourse];
        link.hidden = !selected.includes(course);
        visible = visible || !link.hidden;
      });
      programmes.hidden = !visible;
    }
    const copy = selected.join(' · ');
    if (title && title.textContent !== copy) title.textContent = copy;
    if (help && registration.dataset.selectedCopy && help.textContent !== registration.dataset.selectedCopy) help.textContent = registration.dataset.selectedCopy;
  };
  const applySelection = () => {
    const inputs = choices();
    if (!inputs.length) return;
    if (!applied) {
      applied = true;
      const choice = inputs.find(input => courseName(input.value) === requested);
      if (choice && !inputs.some(input => input.checked)) {
        choice.checked = true;
        choice.dispatchEvent(new Event('input', { bubbles: true }));
        choice.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    syncBanner();
    observer.disconnect();
  };
  registration.addEventListener('change', event => {
    if (event.target.name === 'Quelles formations vous intéressent ?') syncBanner();
  });
  const observer = new MutationObserver(applySelection);
  observer.observe(registration, { childList: true, subtree: true });
  applySelection();
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();

